import React from "react";
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';
import BlankLink from '../elements/BlankLink';
import {featuresRoute} from "../../config/app";

class MenuItem extends React.PureComponent {
    menuClickHandler = () => {
        let { onClick, location, link } = this.props;

        if (location.pathname.indexOf(featuresRoute) >= 0 && link === featuresRoute) {
            window.scrollTo(0, 0);
        }

        if (onClick) {
            onClick();
        }
    };
    render() {
        let { link, text, className, target, location, children } = this.props;

        const isActive = `${location.pathname}${location.hash}` === link;

        const linkClass = 'menu-item ' + (className ?? '') + (isActive ? ' active' : '');

        if (/#/.test(link)) {
            return <HashLink  className={linkClass} to={link}>{text}</HashLink>
        }

        if (target) {
            return <BlankLink className={linkClass} link={link} text={text}/>
        }

        return (
            <NavLink
                onClick={this.menuClickHandler}
                className={linkClass}
                activeClassName={''}
                to={link}>{children ? children : text}</NavLink>
        );
    }
}

export default withRouter(MenuItem);

PropTypes.propTypes = {
    onClick: PropTypes.func.isRequired,
    link: PropTypes.string.isRequired,
    text: PropTypes.string,
    children: PropTypes.node,
};
